import { render, staticRenderFns } from "./Secados.vue?vue&type=template&id=5d78b9d5&scoped=true&"
import script from "./Secados.vue?vue&type=script&lang=js&"
export * from "./Secados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d78b9d5",
  null
  
)

export default component.exports